// import { Helmet } from "react-helmet";
import React , { useEffect, useState} from "react";
import {CalendlyModal} from "~/components/elements/CalendlyModal";
import { MediaImage } from '~/components/elements/Media';

import "~/styles/plano-texas.css";
import "~/styles/doyles-town.css";
export const MeetSpecialist = (props) => {   
  const { starImage, heading, priceIcon, designation, title, subTitle, sectionClass, image, iconWithContent, iconWithTitle = [], links } = props;      
  return (
    <>
    <section className="bg-[#f6f9ff] main-section-meet-specialist py-[100px] font-sans">
      <div className={`main-content-section max-w-7xl mx-auto flex flex-col-reverse md:flex-row items-center md:gap-10  ${sectionClass}`}>
       
        {/* Left - Image */}
        <div className="w-full max-w-[363px] flex-shrink-0 pt-meet-specialist-img">
          <MediaImage 
            image={image} 
            className=" object-cover w-full pt-specialist-img" 
            alt="" 
            sizes="(max-width: 768px) 100vw, 300px"
          />
        </div>

        {/* Right - Content */}
        <div className="flex-1 text-gray-800 pt-meet-specialist-content">
          <div className="mb-6 pt-specialist-btn">
            <span className="inline-block bg-blue-100 text-blue-800 text-xs font-semibold px-3 py-1 uppercase tracking-wide ">
              {subTitle}
            </span>
          </div>
          <h2 className="text-3xl md:text-4xl font-bold text-blue-900 mb-6 leading-[58px]">
            {title}
          </h2>
          <h3 className=" italic text-blue-700 mb-5">
            {designation}
          </h3>

          <div className="space-y-4 text-sm leading-relaxed text-gray-700 pt-detailed-list">
            {iconWithContent.slice(0, 1).map((item, index) => (
              <div key={`icon-${index}`} className="flex items-start gap-3">
                {item.icon?.localFile?.publicURL && (
                  <img
                    src={item.icon.localFile.publicURL}
                    alt={item.icon.altText || `Step ${index + 1}`}
                    className="w-[30px] h-[31px]"
                  />
                )}
                <div className="meet-specialist-content w-[587px]" dangerouslySetInnerHTML={{ __html: item.content }} />
              </div>
            ))}

            <div className="hidden md:block">
                {iconWithContent
                  .slice(1)
                  .map((item, index) => (
                    <div key={`icon-${index + 1}`} className="flex items-start gap-3 mt-3">
                      {item.icon?.localFile?.publicURL && (
                        <img
                          src={item.icon.localFile.publicURL}
                          alt={item.icon.altText || `Step ${index + 2}`}
                          className="w-[30px] h-[31px]"
                        />
                      )}
                      <div className="meet-specialist-content w-[587px]" dangerouslySetInnerHTML={{ __html: item.content }} />
                    </div>
                  ))}
            </div>
          </div>

          {/* Icons */}
          <div className="mt-8 grid grid-cols-2 sm:grid-cols-4 gap-6 text-center pt-icon-with-title">
            {iconWithTitle && iconWithTitle.map((item, index) => (
              <div className="flex flex-col gap-[22px] items-center pt-data" key={index}>
                {item.iconBox?.localFile?.publicURL ? (
                  <img
                    src={item.iconBox.localFile.publicURL}
                    alt={item.title}
                    className="w-[51px] h-[51px] object-contain "
                  />
                ) : (
                  <span className="text-blue-700 text-xl mb-2">📊</span>
                )}
                <p className="text-[18px] font-medium text-[rgb(82, 82, 91)] pt-icon-title text-left">{item.title}</p>
              </div>
            ))}
          </div>


          {/* Link the clendely popup button */}
          {links && (
            <div className="flex flex-col sm:flex-row gap-9  items-center mt-6">

              {links && (
                <div className="flex flex-col sm:flex-row gap-9  items-center mt-6">
                  {links.map((item, idx) => {           
                    const type = item?.type;
                    const link = item?.link;
                    const [modalOpen, setModalOpen] = useState(false);   
                    const isPrimary = idx === 0;
                    const buttonUrl = link?.url;
                    const isCalendly = type === "calendly";
                    const buttonClass = `rounded-full px-6 py-3 font-semibold text-[16px] shadow-md transition-all duration-300 ${
                      isPrimary
                        ? "bg-gradient-to-r bg-gradient-custom text-white hover:opacity-90 pt-book-appointment-button"
                        : "bg-white text-[#2664EB] border border-gray-300 hover:bg-gray-50 pt-contact-button"
                    }`;
                    return (
                        <>
                          {isCalendly ? (
                            <>
                              <CalendlyModal isOpen={modalOpen} onClose={() => setModalOpen(false)} calendlyUrl={buttonUrl} />
                              <button key={idx} onClick={() => setModalOpen(true)} className={`pt-clandly-button rounded-full px-6 py-3 font-semibold text-[16px] shadow-md transition-all duration-300 ${isPrimary ? "bg-primary text-white" : "bg-primary text-[#2664EB] border border-gray-300 hover:bg-gray-50"}`}>
                                {link?.title}
                              </button>
                            </>
                          ) : (
                            <a key={idx} href={buttonUrl} className={buttonClass}>
                              {link?.title}
                            </a>
                          )}
                        </>
                    );
                  })}
                </div>
              )}

            </div>
				  )}
        </div>
      </div>
    </section>
    </>
  );

};

